import Phaser from 'phaser';
import {gsap} from 'gsap';

import HitTest from './_hittest';


export default class EggItem{

    constructor(data, _setIndex, x, y){
        this.scene = GAME_REF.scene;

        this.data = data;
        this.setIndex = _setIndex;
        this.def_x = x;
        this.def_y = y;
        this.def_angle = Math.random()>0.5 ? 14 : -14;

        this.birthpos = 'left';
        if(this.setIndex==2 || this.setIndex==7){
            this.birthpos = 'center';
        }
        else if(this.setIndex==3 || this.setIndex==4 || this.setIndex==8 || this.setIndex==9){
            this.birthpos = 'right';
        }

        this.container = null;
        this.inner = null;
        this.egg = null;
        this.fruit = null;

        this.hitTest = new HitTest();

        this.tween = null;
        this.birthTimer = null;
        this._pause = this._pause.bind(this);
        this._resume = this._resume.bind(this);

        this._init();
    }


    render(){
        this.scene.tweens.add({
            targets: this.container,
            alpha: 1,
            scaleX: 1,
            scaleY: 1,
            duration: 700,
            delay: Math.floor(Math.random() * 500),
            ease: 'Cubic.easeOut'
        });

        window.addEventListener(PLAYBACK.EVENT.PAGE_PAUSE, this._pause);
        window.addEventListener(PLAYBACK.EVENT.PAGE_RESUME, this._resume);
    }


    destroy(){
        window.removeEventListener(PLAYBACK.EVENT.PAGE_PAUSE, this._pause);
        window.removeEventListener(PLAYBACK.EVENT.PAGE_RESUME, this._resume);

        this.container.removeAll(true);
        this.container.destroy();
    }


    startSwing(callback) {
    
        this.scene.tweens.add({
            targets: this.inner,
            angle: Phaser.Math.Between(-10, 10),
            ease: 'Sine.easeInOut',
            duration: 100,
            yoyo: true,
            repeat: 3,
            delay: Phaser.Math.Between(0, 5000),
            callbackScope: this,
            onComplete: callback
        });
    }


    _init(){
        this._create();
        this._setDrag();
    }


    _create(){
        this.container = this.scene.add.container(this.def_x, this.def_y);
        this.container.angle = this.def_angle;
        this.container.alpha = 0;
        this.container.setScale(1.2);

        this.inner = this.scene.add.container(0, 0);
        this.container.add(this.inner);

        this.egg = this.scene.add.sprite(0, 0, 'playing_egg');
        this.egg.setFrame(this.data.frame);
        this.inner.add(this.egg);

        // ripple
        this.ripple1 = this.scene.add.image(0, 0, 'playing_ripple');
        this.ripple1.setScale(0.5);
        this.ripple1.setVisible(false);
        this.inner.add(this.ripple1);

        this.ripple2 = this.scene.add.image(0, 0, 'playing_ripple');
        this.ripple2.setScale(0.25);
        this.ripple2.setVisible(false);
        this.inner.add(this.ripple2);

        this.ripple3 = this.scene.add.image(0, 0, 'playing_ripple');
        this.ripple3.setScale(0);
        this.ripple3.setVisible(false);
        this.inner.add(this.ripple3);

        // fruit
        this.fruit = this.scene.add.sprite(0, 0, 'playing_fruit');
        this.fruit.setFrame(this.data.frame);
        this.inner.add(this.fruit);


        this.tween = this.scene.tweens.add({
            targets: this.inner,
            angle: -this.def_angle/2,
            ease: 'Sine.easeInOut',
            duration: 400, 
            yoyo: true,
            repeat: -1,
            paused: true, // 初期状態ではTweenは停止した状態にします。
        });
    }

    _rippleAnime(_target, _duration){
        _target.setVisible(true);

        this.scene.tweens.add({
            targets: _target,
            scale: 1,
            alpha: 0,
            duration: _duration,
            ease: 'Cubic.easeOut',
            repeat: -1
        });
    }


    _setDrag(){
        this.egg.setInteractive(new Phaser.Geom.Rectangle(0, 0, this.egg.width, this.egg.height), Phaser.Geom.Rectangle.Contains);
        this.egg.input.pixelPerfectOver = true; // 透明領域を除外する
        this.scene.input.setDraggable(this.egg);

        this.egg.on('pointerover', ()=>{
            if(!GAME_REF.obj.eggs.isDraggable) return;
            this.scene.input.setDefaultCursor('pointer');
        });

        this.egg.on('pointerout', ()=>{
            this.scene.input.setDefaultCursor('default');
        });

        this.egg.on('drag', (pointer, gameObject, dragX, dragY)=>{
            if(!GAME_REF.obj.eggs.isDraggable) return;
            this.container.x = pointer.x;
            this.container.y = pointer.y;
            this.container.setDepth(20);

            this.tween.resume();
        });

        this.egg.on('dragend', (pointer, gameObject)=>{
            if(!GAME_REF.obj.eggs.isDraggable) return;
            
            this.scene.input.setDefaultCursor('default');
            
            this.tween.pause();
            
            // 衝突判定
            const hitItem = this.hitTest.check(this);
            if(hitItem){
                if(hitItem.data.key === this.data.key) this._correct(hitItem);
                else this._uncorrect();
            }
            else{
                this._uncorrect();
            }
        });
    }


    _correct(hitItem){
        GAME_REF.obj.sound.playOne('se_correct');
        GAME_REF.obj.eggs.showAnswer(this.data.key, hitItem.def_x, hitItem.def_y);
        GAME_REF.obj.manager.timerstop();

        this.scene.tweens.add({
            targets: this.container,
            x: hitItem.def_x,
            y: hitItem.def_y,
            duration: 200,
            ease: 'Cubic.easeOut',
            onComplete:()=>{
                hitItem.container.setVisible(false);
            }
        });

        this.scene.tweens.add({
            targets: this.inner,
            angle: -this.def_angle*1.5,
            ease: 'Sine.easeInOut',
            duration: 100, 
            delay: 200,
            yoyo: true,
            repeat: 1,
            onComplete: ()=>{

                this.scene.tweens.add({
                    targets: this.inner,
                    angle: -this.def_angle*0.5,
                    ease: 'Sine.easeInOut',
                    duration: 100, 
                    delay: 200,
                    yoyo: true,
                    repeat: -1
                });
            }
        });

        this.scene.tweens.add({
            targets: this.fruit,
            scaleX: 1.7,
            scaleY: 1.7,
            y: '-=40',
            duration: 350,
            delay: 50,
            ease: 'Back.easeOut',
            onComplete:()=>{

                this.scene.tweens.add({
                    targets: this.fruit,
                    scaleX: 1.65,
                    scaleY: 1.65,
                    ease: 'Sine.easeInOut',
                    duration: 200, 
                    yoyo: true,
                    repeat: -1
                });

                this._rippleAnime(this.ripple1, 0);
                this._rippleAnime(this.ripple2, 500);
                this._rippleAnime(this.ripple3, 1000);
            }
        });

        this.birthTimer = gsap.delayedCall(2.0, ()=>{
            GAME_REF.obj.manager.correct(this.data.frame, hitItem.birthpos);
            GAME_REF.obj.eggs.removeItem(this);
            GAME_REF.obj.eggs.removeItem(hitItem);
            this.birthTimer = null;
        });
    }


    _uncorrect(){

        this.scene.tweens.add({
            targets: this.container,
            x: this.def_x,
            y: this.def_y,
            duration: 700,
            ease: 'Cubic.easeOut',
        });

        this.container.setDepth(1);
        GAME_REF.obj.sound.playOne('se_failed');
    }


    _pause(){
        if(this.birthTimer) this.birthTimer.pause();
    }

    _resume(){
        if(this.birthTimer) this.birthTimer.resume();
    }
}